import { ValueGetterParams } from "ag-grid-community";
import { roundValue } from "lib/number";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";
import { getChildrenPlanRow } from "./plan-rows";
import { MergedColumnFormulaOptions } from "./types";
import { getChildrenUnits } from "./units";

/**
 * All this function does is averaging values from children rows.
 */
export const AVERAGE_DEPTH = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const unitsValue = referenceMetricValueOrCompute(
        () => getChildrenUnits(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.UNITS
    );
    const planRows = referenceMetricValueOrCompute(
        () => getChildrenPlanRow(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.PLAN_ROWS
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (unitsValue === undefined || isNaN(unitsValue)) {
        return 0;
    }

    if (planRows === 0) {
        return 0;
    }

    return unitsValue > 0 ? roundValue(unitsValue / planRows, options.decimal) : 0;
};
